import React from 'react';

export const PatientVerified = ({ isPatientVerified, setIsPatientVerified }) => {
	return (
		<div className="p-4 bg-gray-100 rounded-md mb-3">
			<label className="flex items-center gap-3 text-base cursor-pointer">
				<span className="flex items-center">
					<input
						type="checkbox"
						checked={Boolean(isPatientVerified)}
						onChange={(event) => setIsPatientVerified(event.target.checked)}
						className="h-6 w-6 rounded border-gray-300 text-[#10b981] focus:ring-[#10b981]"
					/>
				</span>
				<h2>Patient Verified</h2>
			</label>
		</div>
	);
};
